import { Link } from "@tanstack/react-router";
import {
  ColoredCardInfo,
  ColoredCardInfoButton,
  ColoredCardInfoDescription,
  ColoredCardInfoHeader,
  ColoredCardInfoTitle,
} from "@/components/colored-card-info";

export const HomeSectionOneLivEmptyState = (): JSX.Element => {
  return (
    <Link to="/oneliv/welcome">
      <ColoredCardInfo className="bg-[#4F4FF7]">
        <ColoredCardInfoHeader>
          <ColoredCardInfoTitle className="text-white">
            Ative seu perfil Oneliv
          </ColoredCardInfoTitle>
          <ColoredCardInfoDescription className="text-white">
            A Oneliv te dá acesso aos mais de 25.000 pacientes que navegam pelo site todo
            mês. Mais pacientes, menos complicação!
          </ColoredCardInfoDescription>
        </ColoredCardInfoHeader>
        <ColoredCardInfoButton className="bg-[#B6E6B0] text-[#4F4FF7]">
          Criar perfil
        </ColoredCardInfoButton>
      </ColoredCardInfo>
    </Link>
  );
};
